<template>
  <div class="smart_point-selection-container">
    <div v-if="!getIsSmartPointOnlyTransporter" class="smart_point-selection-pickup-home">
      <label for="pickUpHome">
        <input
          id="pickUpHome"
          type="radio"
          v-on:click="smartPointUncheck"
          :checked="!getSmartPointIsSelected"
        >
        {{ t('preview.order.smartpoints.pickup.at.home') }}
      </label>
    </div>
    <div v-show="getIsSmartPointAllOptionsTransporter"  class="smart_point-selection-pickup-point">
      <label for="pickUpPoint" class="smart_point-selection-pickup-point-label">
        <input
          name="smartPointChecked"
          ref="pickUpPoint"
          type="radio"
          id="pickUpPoint"
          :value="getSmartPointIsSelected ? 1 : 0"
          :checked="getSmartPointIsSelected"
          v-on:click="smartPointClickEvent()"
        >
        {{ t('preview.order.smartpoints.pickup', { params: [{ transporterName: getSelectedTransporterClassName }] }) }}
      </label>
      <div class="smart_point-tooltip">
        <i class="lni lni-question-circle"></i>
        <span class="smart_point-tooltip-text" v-html="t('preview.order.smartpoints.tooltip', {params: [{transporterName: getSelectedTransporterClassName}]})"></span>
      </div>
    </div>
    <div v-if="shouldDisplaySmartPointSelectionError"
         class="smart-point-selected error">
      <span class="smart-point-selected-text-error">{{ t('preview.order.smartpoints.error.msg') }}</span>
    </div>
    <div class="smart_point-selection-input">
      <input type="hidden" name="smartPointJsonData" :value="JSON.stringify(getSelectedSmartPoint)">
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SmartPointsSelection',
  data () {
    return {
      version: '0.0.1',
      selectedTransporter: null
    }
  },
  computed: {
    ...mapGetters([
      'getSmartPointIsSelected',
      'getSelectedTransporterClassName',
      'getSelectedTransporterSmartPoints',
      'getCustomerPostalCode',
      'getSelectedSmartPoint',
      'getPreviousPostalCodeInput',
      'getSelectedTransporterDeliveryOptionType',
      'getSelectedTransporterSmartPointEnable',
      'getIsSmartPointOnlyTransporter',
      'googleService',
      'getSearchInputSmartPoints',
      'getSelectedTransporterSmartPoints',
      'getCurrentUserGeolocation',
      'getIsSmartPointAllOptionsTransporter'
    ]),
    shouldDisplaySmartPointSelectionError () {
      return (
        this.getSelectedSmartPoint.id === 0 &&
        this.getSelectedTransporterSmartPointEnable &&
        this.getIsSmartPointOnlyTransporter
      ) || (
        this.getSelectedSmartPoint.id === 0 &&
        this.getSelectedTransporterSmartPointEnable &&
        !this.getIsSmartPointOnlyTransporter &&
        this.getSmartPointIsSelected
      )
    }
  },
  methods: {
    async smartPointClickEvent () {
      await this.$store.dispatch('smartPointClickEvent').then(
        () => this.$parent.$refs[`smartPointModal${this.getSelectedTransporterClassName}`].openModal()
      )
    },
    smartPointUncheck () {
      this.$store.dispatch('smartPointUncheck')
    }
  }
}
</script>

<style lang="scss" scoped>
.smart_point-tooltip {
  position: relative;
  display: inline-block;
  &:hover {
    cursor: pointer;
    i {
      font-weight: 700;
    }
    .smart_point-tooltip-text {
      visibility: visible;
    }
  }
  &-text {
    visibility: hidden;
    width: 200px;
    font-size: 12px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    bottom: 15px;
    position: absolute;
    z-index: 1;
    @media screen and (max-width: 767px) {
      right: 0;
    }
  }
}
.smart_point-response-error {
  font-size: 12px;
  color: red;
}
.smart_point-selection-pickup-point-label {
  &:hover {
    cursor: pointer;
  }
}
.smart_point-selection-pickup-point {
  @media screen and (max-width: 767px) {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    justify-items: center;
  }
}
</style>
